export default "__VITE_ASSET__DVA0eLK5__"